//import { authAdmin } from '../middleware/isAuth';
import VueRouter from 'vue-router';

const routeMain = new VueRouter({
   mode: 'history',
   routes: [
      {
         path: '/',
         redirect: { name: 'quiz2' },
      },
      {
         path: '/home',
         redirect: { name: 'quiz2' },
      },
      // {
      //    path: '/quiz',
      //    name: 'quiz',
      //    component: () => import('../../views/TheQuiz.vue'),
      // },      
      {
         path: '/quiz2',
         name: 'quiz2',
         component: () => import('../../views/TheQuiz2.vue'),
      },
      {
         path: '/results2',
         name: 'results2',
         component: () => import('../../views/TheResults2.vue'),
      },
      {
         path: '/login',
         name: 'login',
         component: () => import('../../views/TheLogin.vue'),
         children: [
            {
               path: 'name',
               name: 'name',
               component: () => import('../../views/ContactsName.vue'),
            },
            {
               path: 'register',
               name: 'register',
               component: () => import('../../views/ContactsRegister.vue'),
            },
         ],
      },
      {
         path: '/auth/google',
         name: 'auth-google',
         component: () => import('../../views/TheAuthGoogle.vue'),
      },
      {
         path: '/auth/facebook',
         name: 'auth-facebook',
         component: () => import('../../views/TheAuthFacebook.vue'),
      },
      {
         path: '/auth/twitter',
         name: 'auth-twitter',
         component: () => import('../../views/TheAuthTwitter.vue'),
      },
      {
         path: '/privacy-policy',
         name: 'privacy-policy',
         component: () => import('../../views/ThePrivacy'),
      },
      {
         path: '/terms-of-service',
         name: 'terms-of-service',
         component: () => import('../../views/TheTerms'),
      },
      {
         path: '/registration',
         name: 'registration',
         component: () => import('../../views/TheRegistration.vue'),
      },
      {
         path: '/confirmemail',
         name: 'confirmemail',
         component: () => import('../../views/TheConfirmemail.vue'),
      },
      {
         path: '/registerphone',
         name: 'registerphone',
         component: () => import('../../views/TheRegisterPhone.vue'),
      },

      {
         path: '/*',
         name: '404',
         component: () => import('../../views/The404Page.vue'),
      },
   ],
});

export default routeMain;
